
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Button, Heading, Text, useTheme, VStack } from '@chakra-ui/react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import EmailInput from '../../components/Molecules/EmailInput';
import FormControlContainer from '../../components/Molecules/FormControlContainer';
import { USER_SIGN_IN, USER_SIGN_UP } from '../../constants/routes';
import { useIsMobile } from '../../hooks/useIsMobile';
import { getRedirectTo } from '../../utils/loginHelper';
import HeadModule from '../../components/Modules/HeadModule';
import useTranslation from 'next-translate/useTranslation';
import { useResetPassword } from '../../hooks';
const ResetPassword = () => {
    const theme = useTheme();
    const [, resetPassword] = useResetPassword();
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const { register, handleSubmit, formState: { errors, isSubmitting }, } = useForm();
    const onSubmit = async (values: any) => {
        const showToast = await import('../../utils/showToast').then(mod => mod.showToast);
        const { error } = await resetPassword(values.email, {
            redirectTo: getRedirectTo(),
        });
        showToast(t('login:login_modal_password_reset_toast_desc'), 'success');
        if (error) {
            showToast(error.message, 'error');
        }
    };
    return (<>
      <HeadModule title='meta_title_home' description='meta_description_profile'/>
      <VStack spacing={0} alignItems='stretch'>
        <Heading textAlign='center' variant='large' color={theme.colors.text.basic} mb={10}>
          {t('profile:profile_reset_password_title')}
        </Heading>
        <VStack spacing={5}>
          <VStack p={10} px={isMobile ? 5 : 10} spacing={5} background={theme.colors.layers.appLevel1} w='100%' maxW='470px' borderRadius={theme.radii.big}>
            <Text variant='mediumBold' color={theme.colors.text.basic}>
              {t('profile:profile_reset_password_subtitle')}
            </Text>
            <Text variant='medium' color={theme.colors.text.basic}>
              {t('profile:profile_reset_password_description')}
            </Text>
            <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
              <FormControlContainer name='email' errors={errors}>
                <EmailInput register={register}/>
              </FormControlContainer>
              <Button variant='loginButton' type='submit' isLoading={isSubmitting} rightIcon={<FontAwesomeIcon icon={faChevronRight} size='sm'/>}>
                {t('profile:profile_reset_password_button')}
              </Button>
            </form>
          </VStack>
          <Link href={USER_SIGN_IN} passHref>
            <Button variant='textLight'>{t('profile:profile_link_create_an_account')}</Button>
          </Link>
          <Link href={USER_SIGN_UP} passHref>
            <Button variant='textLight'>{t('profile:profile_link_sign_in')}</Button>
          </Link>
        </VStack>
      </VStack>
    </>);
};
// noinspection JSUnusedGlobalSymbols
export default ResetPassword;

    async function __Next_Translate__getStaticProps__196fbffbb97__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/profile/reset-password',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196fbffbb97__ as getStaticProps }
  